export const MSG_KO: Record<string, string>  = {
  DEFAULT_MESSAGE: 'Please try again later.',
  DEFAULT_ERROR_MESSAGE: 'Please try again later.',
  SUCCESS_CATCH_ALL: '모든 아이템을 찾아 주셨네요! 이벤트에 참여해 주셔서 감사합니다!',
  SUCCESS_CATCH: '이벤트에 참여해 주셔서 감사합니다! CM목각인형의 잃어버린 무기도 찾아주세요!',
  // SUCCESS_CATCH_ALL: '수집 가능한 스탬프를 모두 획득하셨습니다!(4/4)',
  'event.iconsEvent.NOT_EXIST_SCHEDULE':'진행중인 이벤트가 없습니다.',  // 진행중인 이벤트가 없음
  'event.iconsEvent.NOT_START_SCHEDULE': '이벤트 시작 전입니다.', // 이벤트 시작 전
  'event.iconsEvent.ALREADY_END_SCHEDULE': '이벤트가 종료 되었습니다.', // 이벤트 시작 종료
  'event.iconsEvent.UNAUTHORIZED_USER_ID': '로그인이 필요합니다.',  // 로그인이 안되어 있는 상태
  'event.iconsEvent.INVALID_PARAMETER': '', // 저장 parameter가 누락된 경우
  'event.iconsEvent.INVALID_ICON_ID': '', // iconId가 유효하지 않은 경우
  'event.iconsEvent.ALREADY_COLLECTED_ICON_ID': '이미 최대 횟수까지 수집한 아이콘 입니다.', // 이미 최대 횟수까지 수집한 아이콘
  'event.iconsEvent.SYSTEM_ERROR': '' // 시스템 에러
};

export const MSG_ZH: Record<string, string>  = {
  DEFAULT_MESSAGE: 'Please try again later.',
  DEFAULT_ERROR_MESSAGE: 'Please try again later.',
  SUCCESS_CATCH: '感謝您的參與! 也請幫忙找出CM木刻人偶\n遺失的武器!',
  SUCCESS_CATCH_ALL: '感謝您幫忙找回所有道具! 您已完成活動!',
  // ITEM_1: 'CM硬幣II 10個',
  // ITEM_2: 'CM硬幣II 30個',
  // ITEM_3: 'CM硬幣II 50個',
  // SUCCESS_CATCH: '幸運之幣箱中獲得了${item}！( ${quantity} / ${total} )',
  // SUCCESS_CATCH_ALL: '스탬프를 획득하셨습니다!\n(${quantity}/${total})',
  // 'p20211025.iconsEvent.EXCESS_TOTAL_ICONS': '已收集完成所有幸運之幣箱！( 3 / 3 )',
  // 'p20220824.iconsEvent.EXCESS_TOTAL': '已收集完成所有幸運之幣箱！( 3 / 3 )',
  // 'p20211025.iconsEvent.EXCESS_DAYLY_ICONS': '道具不論種類，每天最多可獲得10個。',
};

export const MSG_JA: Record<string, string>  = {
  DEFAULT_MESSAGE: 'Please try again later.',
  DEFAULT_ERROR_MESSAGE: 'Please try again later.',
  SUCCESS_CATCH: 'イベントにご参加いただき\nありがとうございます！ CM木彫り人形の失われた\n武器も探してください！',
  SUCCESS_CATCH_ALL: 'すべてのアイテムを探して\nいただきありがとうございます！ イベントへの参加が\n完了しました！',
  // ITEM_1: 'CMコイン II 10個',
  // ITEM_2: 'CMコイン II 30個',
  // ITEM_3: 'CMコイン II 50個',
  // SUCCESS_CATCH: '幸運のコイン箱から${item}を獲得しました! ( ${quantity} / ${total} )',
  // SUCCESS_CATCH_ALL: '스탬프를 획득하셨습니다!\n(${quantity}/${total})',
  // 'p20211025.iconsEvent.EXCESS_TOTAL_ICONS': '収集可能な幸運のコイン箱を全て獲得しました! ( 3 / 3 )',
  // 'p20220824.iconsEvent.EXCESS_TOTAL': '収集可能な幸運のコイン箱を全て獲得しました! ( 3 / 3 )',
  // 'p20211025.iconsEvent.EXCESS_DAYLY_ICONS': 'アイテムは種類と関係なく、一日最大10個まで獲得可能です。',
};

export const MSG_EN: Record<string, string>  = {
  DEFAULT_MESSAGE: 'Please try again later.',
  DEFAULT_ERROR_MESSAGE: 'Please try again later.',
  SUCCESS_CATCH: 'Thank you for participating the event! Please also find CM Wooden Doll\'s lost weapon!',
  SUCCESS_CATCH_ALL: 'Thank you for finding all the items! Event participation is complete!',
  // ITEM_1: 'CM Coin II x10',
  // ITEM_2: 'CM Coin II x30',
  // ITEM_3: 'CM Coin II x50',
  // SUCCESS_CATCH: 'Obtained ${item} from Lucky Coin Chest! ( ${quantity} / ${total} )',
  // SUCCESS_CATCH_ALL: '스탬프를 획득하셨습니다!\n(${quantity}/${total})',
  // 'p20211025.iconsEvent.EXCESS_TOTAL_ICONS': 'Obtained all collectible Lucky Coin Chest! ( 3 / 3 )',
  // 'p20220824.iconsEvent.EXCESS_TOTAL': 'Obtained all collectible Lucky Coin Chest! ( 3 / 3 )',
  // 'p20211025.iconsEvent.EXCESS_DAYLY_ICONS': 'You can collect up to 10 items a day, regardless of item type.',
};


/*
export const MSG_TH: Record<string, string>  = {
  DEFAULT_MESSAGE: 'Please try again later.',
  DEFAULT_ERROR_MESSAGE: 'Please try again later.',
  // ITEM_1: 'CM II จำนวน 10',
  // ITEM_2: 'CM II จำนวน 30',
  // ITEM_3: 'CM II จำนวน 50',
  // SUCCESS_CATCH: 'คุณได้รับ ${item}!\n(${quantity}/${total})',
  // SUCCESS_CATCH: 'ได้รับเหรียญ ${item} อันจากหีบเหรียญโชคดี! ( ${quantity} / ${total} )',
  // SUCCESS_CATCH_ALL: '스탬프를 획득하셨습니다!\n(${quantity}/${total})',
  // 'p20211025.iconsEvent.EXCESS_TOTAL_ICONS': 'ได้รับหีบเหรียญโชคดีครบทั้งหมดแล้ว! ( 3 / 3 )',
  // 'p20220824.iconsEvent.EXCESS_TOTAL': 'ได้รับหีบเหรียญโชคดีครบทั้งหมดแล้ว! ( 3 / 3 )',
  // 'p20211025.iconsEvent.EXCESS_DAYLY_ICONS': 'คุณสามารถเก็บไอเทมได้สูงสุด 10 ชิ้นต่อวัน โดยไม่คำนึงถึงประเภทของไอเทม',
};

export const MSG_ID: Record<string, string>  = {
  DEFAULT_MESSAGE: 'Please try again later.',
  DEFAULT_ERROR_MESSAGE: 'Please try again later.',
};

export const MSG_AR: Record<string, string>  = {
  DEFAULT_MESSAGE: 'Please try again later.',
  DEFAULT_ERROR_MESSAGE: 'Please try again later.',
  // ITEM_1: '10 من عملة CM',
  // ITEM_2: '30 من عملة CM',
  // ITEM_3: '50 من عملة CM',
  // SUCCESS_CATCH: 'لقد حصلت على ${item}! (${quantity}/${total})',
  // SUCCESS_CATCH: 'قد حصلت على ${item} الثانية من صندوق العملات المحظوظ! ( ${quantity} / ${total} )',
  // SUCCESS_CATCH_ALL: '스탬프를 획득하셨습니다!\n(${quantity}/${total})',
  // 'p20211025.iconsEvent.EXCESS_TOTAL_ICONS': 'لقد حصلت على جميع صناديق العملات المحظوظة القابلة للتحصيل! ( 3 / 3 )',
  // 'p20220824.iconsEvent.EXCESS_TOTAL': 'لقد حصلت على جميع صناديق العملات المحظوظة القابلة للتحصيل! ( 3 / 3 )',
  // 'p20211025.iconsEvent.EXCESS_DAYLY_ICONS': 'يمكنك تجميع ما يصل إلى 10 عناصر في اليوم، بغض النظر عن نوع العنصر.',
};
*/

function setMsg(){
  let lang = document.documentElement.getAttribute('lang');
  switch (lang){
    case 'ko':
      return MSG_KO;
    case 'zh':
      return MSG_ZH;
    case 'ja' :
      return MSG_JA;
    default :
      return MSG_EN;
  }
}

export const MAPPED_CODE_TO_MESSAGE: Record<string, string> = setMsg();
